import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=522a4d9a&scoped=true&"
import script from "./Unit.vue?vue&type=script&lang=js&"
export * from "./Unit.vue?vue&type=script&lang=js&"
import style0 from "./Unit.vue?vue&type=style&index=0&id=522a4d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a4d9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
